// extracted by mini-css-extract-plugin
export default {"callApp":"index_callApp_FpkCu"};